const divisionsMock = [
  {
    locality: '',
    item: [
      {
        id: '',
        name: '',
        address: '',
        pictureId: '',
        description: '',
        timezone: '',
      },
    ],
  },
];

export const widgetMock = {
  id: '',
  name: '',
  company: {
    name: '',
    type: '',
    description: '',
    address: '',
    pictureId: '',
  },
  alias: '',
  duration: '',
  status: '',
  hasRecordingFromMaster: false,
  hasRecordingFromService: false,
  hasRecordingFromDate: false,
  division: undefined as typeof divisionsMock | undefined,
  rejectAllowed: false,
  durationRejectConstraint: '',
  // Group visit
  widgetType: 'individual', // Тип записи в виджете (group/individual)
  additionalPersonsAllowed: false, // разрешить доп.места	true/false
  showBanner: false,
  maxVisitDuration: '',
  controlSettings: {
    buttons: {
      nameButtonMaster: 'Выбрать специалиста',
      nameButtonDate: 'Выбрать дату',
      nameButtonService: 'Выбрать услугу',
      nameButtonAppointment: 'Записаться',
    },
    fields: {
      specialistNominativeCase: 'специалист',
      specialistGenitiveCase: 'специалиста',
      specialistPrepositionalCase: 'О специалисте',
      fieldNameLabel: 'Имя',
      fieldCommentLabel: 'Комментарий',
    },
  },
};
